// ============================================================
// GAME CONFIG — Tất cả balance ở đây, không hard-code ở nơi khác
// ============================================================

export const GAME_CONFIG = {
  // --- World ---
  world: {
    radiusM: 500, // bán kính địa bàn tính bằng mét
    nodeDedupeDistM: 70, // khoảng cách tối thiểu giữa 2 node (m) để phân bố đều
    minNodes: 5,
  },

  // --- Economy ---
  economy: {
    startingMoney: 500_000, // VND
    stoolCost: 50_000,
    chairCost: 150_000,
    umbrellaUpgradeCost: 300_000,
    brandingCost: 500_000,
    baseSpend: 25_000, // VND/khách
    rentCycle: 60_000, // ms — chu kỳ tính tiền thuê
    dailyDepreciation: 25_000, // Khấu hao vật tư thiết bị ban đầu (bàn ghế, dù, thùng đá, phin) mỗi ngày
    staffDailyWage: 120_000,   // Lương 1 người phụ quán / ngày
    soloOrderCapacity: 85,     // Năng lực phục vụ tối đa của 1 người solo / ngày (~85 đơn)
    staffOrderCapacity: 180,   // Năng lực phục vụ khi có thêm phụ quán / ngày (~180 đơn)
    dummyCompetitionRatio: 0.45, // Tỷ lệ khách đường lớn bị các quán cóc dummy xung quanh thu hút
  },

  // --- Traffic ---
  traffic: {
    tickMs: 250, // ms mỗi simulation tick
    baseTraffic: 0.5,
    factors: {
      timePeakMorning: 1.5,  // 7-9h
      timePeakNoon: 1.2,     // 11-13h
      timePeakEvening: 1.4,  // 17-20h
      timeNight: 0.3,        // 22-6h
      road: {
        primary: 1.6,
        secondary: 1.3,
        tertiary: 1.0,
        residential: 0.8,
        living_street: 0.6,
        footway: 0.4,
      },
      poi: {
        school: 1.4,
        hospital: 1.2,
        bus_stop: 1.3,
        market: 1.5,
      },
    },
  },

  // --- Visit probability ---
  visit: {
    base: 0.3,
    maxCrowdPenalty: 0.5, // tối đa giảm 50% khi đông
    capacityCap: 20, // số ghế tối đa 1 quán
  },

  // --- Heat ---
  heat: {
    decayPerTick: 0.001,
    sources: {
      overCapacity: 0.05,
      loudMarketing: 0.08,
      excessiveDiscount: 0.03,
      roadObstruction: 0.1,
      aggressiveRepeat: 0.06,
    },
    sinks: {
      cleanup: -0.05,
      tempClosure: -0.1,
      normalPricing: -0.02,
      assistantUpgrade: -0.03,
    },
    dangerThreshold: 0.7,
    maxHeat: 1.0,
  },

  // --- Territory ---
  territory: {
    comboBonusCap: 0.5, // tối đa +50% revenue từ combo
    comboPerEdge: 0.1,  // +10% mỗi edge kết nối
    monopolyBonus: 0.3, // +30% khi độc quyền tuyến
  },

  // --- Events ---
  events: {
    rain: {
      durationMs: 120_000,
      trafficPenalty: 0.4,
    },
    raid: {
      durationMs: 30_000,
      heatThreshold: 0.6,
      finePct: 0.15, // 15% money hiện tại
    },
    priceWar: {
      durationMs: 60_000,
      trafficBoostWinner: 0.3,
    },
    unpaidBill: {
      durationMs: 25_000,
      lossAmount: 35_000,
    },
    rivalSabotage: {
      durationMs: 45_000,
      trafficPenalty: 0.25,
    },
    streetBrawl: {
      durationMs: 30_000,
      repairCost: 50_000,
    },
    extremeWeather: {
      durationMs: 60_000,
      trafficPenalty: 0.5,
    },
    viralTiktok: {
      durationMs: 60_000,
      trafficBoost: 0.8,
    },
    checkIntervalMs: 60_000, // kiểm tra trigger event mỗi 60s (tránh spam)
    maxConcurrent: 1,
  },

  // --- Daytime Shifts & Weekend ---
  shifts: {
    morning: { name: 'Sáng Sớm', emoji: '🌅', trafficMultiplier: 1.2 },
    noon: { name: 'Buổi Trưa', emoji: '☀️', trafficMultiplier: 1.1 },
    afternoon: { name: 'Chiều Xế', emoji: '🌇', trafficMultiplier: 0.9 },
    evening: { name: 'Tối Náo Nhiệt', emoji: '🏮', trafficMultiplier: 1.4 },
    night: { name: 'Đêm Khuya', emoji: '🌙', trafficMultiplier: 0.7 },
  },
  weekend: {
    name: 'Cuối Tuần',
    pedestrianMultiplier: 1.35,
    officeMultiplier: 0.7,
  },
  overtime: {
    priceBonus: 0.3, // Doanh thu & giá bán +30%
    heatMultiplier: 2.0, // Heat tăng gấp đôi
  },

  // --- Ghost multiplayer ---
  ghost: {
    ttlMs: 48 * 60 * 60 * 1000, // 48 giờ
    staleThresholdMs: 24 * 60 * 60 * 1000, // 24 giờ → render stale
    queryMarginM: 100, // preload thêm 100m ngoài camera
    cellSizeM: 100, // bucket cell 100m × 100m
  },

  // --- AI Narrative ---
  ai: {
    cacheTtlMs: 30 * 60 * 1000, // 30 phút
    timeoutMs: 5_000,
    maxPayloadChars: 500,
  },

  // --- Progression ---
  progression: {
    ranks: ['Quán Cóc', 'Tiệm Nhỏ', 'Chuỗi Phố', 'Bá Chủ Tuyến', 'Vua Vỉa Hè'],
    rankThresholds: [0, 3, 7, 15, 30], // số node để đạt rank
    prestigeNodeThreshold: 30,
  },

  // --- Rendering ---
  render: {
    colors: {
      you: '#FFD700',      // vàng
      rival: '#4FC3F7',    // xanh
      chair: '#EF5350',    // đỏ
      road: '#424242',     // xám đậm
      poiMarker: '#81C784',
      customer: '#F9A825',
      heatLow: '#66BB6A',
      heatHigh: '#E53935',
      background: '#1a1a2e',
      text: '#FAFAFA',
    },
    nodeRadius: 14, // px ở zoom chuẩn
    customerDotRadius: 4,
    minTouchTarget: 44, // px
  },

  // --- Weather ---
  weather: {
    sunny:  { trafficMultiplier: 1.0 },
    cloudy: { trafficMultiplier: 0.9 },
    rainy:  { trafficMultiplier: 0.5 },
    hot:    { trafficMultiplier: 0.8 },
    windy:  { trafficMultiplier: 0.7 },
    changeProbabilityPerDay: 0.6, // 60% mỗi ngày thời tiết thay đổi
  },

  // --- Upgrades ---
  upgrades: {
    umbrella:    { cost: 200_000, trafficBonus: 0.10, reputationBonus: 5,  name: 'Ô Che Nắng',      emoji: '⛱️',  description: 'Khách ngồi mát hơn, +10% traffic' },
    ice_machine: { cost: 350_000, trafficBonus: 0.15, reputationBonus: 8,  name: 'Máy Làm Đá Siêu Tốc', emoji: '🧊', description: 'Đồ uống mát hơn, +15% traffic' },
    signboard:   { cost: 150_000, trafficBonus: 0.08, reputationBonus: 10, name: 'Bảng Hiệu Đẹp',   emoji: '📣',  description: 'Dễ nhận biết hơn, +8% traffic' },
    speaker:     { cost: 100_000, trafficBonus: 0.05, reputationBonus: 3,  name: 'Loa Nhỏ Nhạc Vui',emoji: '🔊',  description: 'Không khí vui, +5% traffic' },
  },
} as const;

export type GameConfig = typeof GAME_CONFIG;
